
export class StatoIntervento {
  id: Number;
  label: String;
  descrizione: String;
  }
